import { useAtomValue } from 'jotai';
import { type ReactElement } from 'react';

import { pickRecommendationAtom } from '../state/draftAtoms';

export default function PickRecommendation(): ReactElement {
  const recommendations = useAtomValue(pickRecommendationAtom);

  if (recommendations.length === 0) return <div />;

  return (
    <div className="space-y-2">
      <h3 className="text-xs font-semibold tracking-wider text-zinc-400 uppercase">Recommended</h3>
      <div className="space-y-1">
        {recommendations.map(({ card, reason }, i) => (
          <div key={card.id} className="flex items-center gap-2 rounded bg-zinc-800/50 px-2 py-1.5">
            <span className="text-xs font-bold text-zinc-500">#{i + 1}</span>
            <span className="min-w-0 flex-1 truncate text-xs font-medium text-zinc-200">{card.name}</span>
            <span className="shrink-0 text-[10px] text-zinc-500">{reason}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
